import React, { useEffect, Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { initMetaPixel } from './utils/metaPixel';
const SocialProof = lazy(() => import('./components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const ProductPreview = lazy(() => import('./components/ProductPreview').then(m => ({
  default: m.ProductPreview
})));
const ForWho = lazy(() => import('./components/ForWho').then(m => ({
  default: m.ForWho
})));
const InstructorTestimonials = lazy(() => import('./components/InstructorTestimonials').then(m => ({
  default: m.InstructorTestimonials
})));
const Benefits = lazy(() => import('./components/Benefits').then(m => ({
  default: m.Benefits
})));
const ContentOverview = lazy(() => import('./components/ContentOverview').then(m => ({
  default: m.ContentOverview
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const Authority = lazy(() => import('./components/Authority').then(m => ({
  default: m.Authority
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      let pixelLoaded = false;
      const loadPixel = () => {
        if (!pixelLoaded) {
          pixelLoaded = true;
          if ('requestIdleCallback' in window) {
            requestIdleCallback(() => initMetaPixel(), {
              timeout: 5000
            });
          } else {
            setTimeout(initMetaPixel, 5000);
          }
        }
      };
      const events = ['scroll', 'click', 'touchstart'];
      events.forEach(event => {
        window.addEventListener(event, loadPixel, {
          once: true,
          passive: true
        });
      });
      const timeout = setTimeout(loadPixel, 10000);
      return () => {
        events.forEach(event => window.removeEventListener(event, loadPixel));
        clearTimeout(timeout);
      };
    }
  }, []);
  return <div className="min-h-screen bg-brand-bg text-brand-text font-body" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />

        <Suspense fallback={null} data-id="element-3">
          <SocialProof data-id="element-4" />
          <ProductPreview data-id="element-5" />
          <ForWho data-id="element-6" />
          <InstructorTestimonials data-id="element-7" />
          <Benefits data-id="element-8" />
          <ContentOverview data-id="element-9" />
          <Bonuses data-id="element-10" />
          <Pricing data-id="element-11" />
          <Guarantee data-id="element-12" />
          <Authority data-id="element-13" />
          <FAQ data-id="element-14" />
          <FinalCTA data-id="element-15" />
        </Suspense>
      </main>

      <Suspense fallback={null} data-id="element-16">
        <Footer data-id="element-17" />
      </Suspense>
    </div>;
}